import React from 'react';

export const QuestionStarIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g>
                <path
                    style={{
                        lineHeight: 'normal',
                        fontVariantLigatures: 'normal',
                        fontVariantPosition: 'normal',
                        fontVariantCaps: 'normal',
                        fontVariantNumeric: 'normal',
                        fontVariantAlternates: 'normal',
                        fontVariantEastAsian: 'normal',
                        fontFeatureSettings: 'normal',
                        fontVariationSettings: 'normal',
                        textIndent: '0',
                        textAlign: 'start',
                        WebkitTextDecorationLine: 'none',
                        textDecorationLine: 'none',
                        WebkitTextDecorationStyle: 'solid',
                        textDecorationStyle: 'solid',
                        WebkitTextDecorationColor: '#000000',
                        textDecorationColor: '#000000',
                        textTransform: 'none',
                        WebkitTextOrientation: 'mixed',
                        textOrientation: 'mixed',
                        whiteSpace: 'normal',
                        shapeMargin: '0',
                        inlineSize: '0',
                        isolation: 'auto',
                        mixBlendMode: 'normal'
                    }}
                    fill="#fff"
                    fillOpacity="1"
                    fillRule="nonzero"
                    stroke="none"
                    strokeDasharray="none"
                    strokeDashoffset="0"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="2"
                    d="M10.889.994L8.83 5.534c-.097.409-.256.804-.478 1.154v.007c-.04.063-.087.118-.13.178l-.326.719-.337.056c-.28.275-.594.55-.971.864-.127.105-.07.039-.133.11v1.29l2.766-.467 1.734-3.83 1.852 3.774 4.015.545-2.857 3.004.748 4.171-3.617-1.918L7.54 17.22l.625-4.192-1.71-1.69v1.804H5.43l.644.638L5.002 21l6.13-3.498 6.223 3.299-.36-2.035-.92-5.149 4.923-5.178-6.922-.945z"
                    baselineShift="baseline"
                    clipRule="nonzero"
                    color="#000"
                    colorInterpolation="sRGB"
                    colorInterpolationFilters="linearRGB"
                    colorRendering="auto"
                    direction="ltr"
                    display="inline"
                    dominantBaseline="auto"
                    enableBackground="accumulate"
                    fontFamily="sans-serif"
                    fontSize="medium"
                    fontStretch="normal"
                    fontStyle="normal"
                    fontVariant="normal"
                    fontWeight="normal"
                    imageRendering="auto"
                    letterSpacing="normal"
                    opacity="1"
                    overflow="visible"
                    shapeRendering="auto"
                    stopColor="#000"
                    stopOpacity="1"
                    textAnchor="start"
                    textDecoration="none"
                    textRendering="auto"
                    transform="scale(.26458)"
                    vectorEffect="none"
                    visibility="visible"
                    wordSpacing="normal"
                    writingMode="lr-tb"
                ></path>
                <g strokeWidth="0.265" transform="translate(.022)">
                    <path
                        d="M1.243 2.43H.804l-.002-.116q0-.214.071-.352.07-.137.282-.31.212-.172.254-.225.063-.085.063-.186 0-.142-.113-.242-.112-.101-.303-.101-.185 0-.309.105t-.17.32l-.445-.055Q.152.96.394.744.64.53 1.034.53q.418 0 .664.219.246.217.246.506 0 .16-.09.304-.09.142-.387.389-.153.127-.19.205-.037.077-.034.277zm-.439.65v-.484h.484v.484z"
                        style={{}}
                        fill="#fff"
                        fillOpacity="1"
                        strokeWidth="0.265"
                        fontFamily="Arial"
                        fontSize="3.528"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                    ></path>
                </g>
            </g>
        </svg>
    );
};
